module.exports = __webpack_public_path__ + "img/table.jpg.bd027307.webp";